import ProgressSlider from '../ProgressSlider';
import * as Styled from './ProgressSliderWrapper.styled';

interface ProgressSliderWrapperProps {
  step: number;
  showResetButton?: boolean;
  resetButtonRedirectUrl?: string;
  maxSteps?: number;
  disabled?: boolean;
}

const ProgressSliderWrapper = ({
  step,
  showResetButton = true,
  resetButtonRedirectUrl,
  maxSteps,
  disabled,
}: ProgressSliderWrapperProps) => {
  return (
    <Styled.Wrapper>
      <ProgressSlider
        disabled={disabled}
        maxSteps={maxSteps}
        resetButtonRedirectUrl={resetButtonRedirectUrl}
        showResetButton={showResetButton}
        step={step}
      />
    </Styled.Wrapper>
  );
};

export default ProgressSliderWrapper;
